import script from "./CashierPublic.vue?vue&type=script&setup=true&lang=js"
export * from "./CashierPublic.vue?vue&type=script&setup=true&lang=js"

import "./CashierPublic.vue?vue&type=style&index=0&id=4672f474&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4672f474"]])

export default __exports__